var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message_wrap" }, [
    _vm.pageDesign === "login"
      ? _c("div", { staticClass: "error_msg_wrap" }, [
          _c("h5", [_vm._v(_vm._s(_vm.message))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("sdl.common.label.reloginmsg")))]),
          _vm._v(" "),
          _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("cop.warning.message.common.scopWillServe")
              )
            }
          }),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("cop.warning.message.common.notEffected")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("cop.warning.message.common.askNumber1")))
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("cop.warning.message.common.askNumber2")))
          ]),
          _c(
            "span",
            {
              staticClass: "move_target",
              on: {
                click: function($event) {
                  return _vm.moveItVoc()
                }
              }
            },
            [_vm._v(_vm._s(_vm.systemItvoc))]
          ),
          _c("br"),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.systemPropMsg))]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-lg btn-primary",
              on: { click: _vm.goLogin }
            },
            [
              _vm._v(
                _vm._s(_vm.$t("sdl.common.label.loginshortcut")) + "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _vm.showErrMsgYn
            ? _c(
                "button",
                {
                  staticClass: "btn btn-lg btn-primary",
                  on: {
                    click: function($event) {
                      return _vm.showErrMsg(_vm.msg)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cop.common.error-msg")))]
              )
            : _vm._e()
        ])
      : _vm.pageDesign === "inactive"
      ? _c(
          "div",
          { staticClass: "error_msg_wrap" },
          [
            _vm.pageDesign === "inactive" && _vm.errorCode === "192"
              ? [
                  _c("h5", [_vm._v(_vm._s(_vm.message))]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("cop.warning.message.content.reconnect1"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "align-items": "center" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("cop.warning.message.content.reconnect2")) +
                        "\n        "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-lg btn-primary",
                        staticStyle: {
                          "margin-top": "0",
                          height: "25px",
                          "margin-left": "10px"
                        },
                        on: { click: _vm.activate }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.warning.message.button.activate"))
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticStyle: { color: "red", "font-weight": "500" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "cop.warning.message.long-term.send-mail-message1"
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticStyle: { color: "red", "font-weight": "500" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "cop.warning.message.long-term.send-mail-message2"
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("cop.warning.message.common.askNumber1"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("cop.warning.message.common.askNumber2"))
                    )
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "move_target",
                      on: {
                        click: function($event) {
                          return _vm.moveItVoc()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.systemItvoc))]
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.systemPropMsg))]),
                  _vm._v(" "),
                  _c("a", { attrs: { href: "javascript:" } }, [
                    _vm._v(_vm._s(_vm.$t("sdl.common.projectHelp")))
                  ])
                ]
              : _vm.pageDesign === "inactive"
              ? [
                  _c("h5", [_vm._v(_vm._s(_vm.message))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("sdl.commonError")))]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("cop.warning.message.common.scopWillServe")
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("cop.warning.message.common.notEffected"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("cop.warning.message.common.askNumber1"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("cop.warning.message.common.askNumber2"))
                    )
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "move_target",
                      on: {
                        click: function($event) {
                          return _vm.moveItVoc()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.systemItvoc))]
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.systemPropMsg))]),
                  _vm._v(" "),
                  _c("a", { attrs: { href: "javascript:" } }, [
                    _vm._v(_vm._s(_vm.$t("sdl.common.projectHelp")))
                  ])
                ]
              : [
                  _c("h4", [_vm._v(_vm._s(_vm.errorTitle))]),
                  _vm._v(" "),
                  _c("h5", [_vm._v(_vm._s(_vm.message))]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("sdl.common.label.goMainPage")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.goMain }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("sdl.common.label.mainShortcut")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("a", { attrs: { href: "javascript:" } }, [
                    _vm._v(_vm._s(_vm.$t("sdl.common.projectHelp")))
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-primary",
                      on: { click: _vm.activate }
                    },
                    [_vm._v("Activate")]
                  )
                ],
            _vm._v(" "),
            _vm.showErrMsgYn
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-primary",
                    on: {
                      click: function($event) {
                        return _vm.showErrMsg(_vm.msg)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.common.error-msg")))]
                )
              : _vm._e()
          ],
          2
        )
      : _vm.pageDesign === "clientServerErr"
      ? _c("div", { staticClass: "error_msg_wrap" }, [
          _c("h5", [_vm._v(_vm._s(_vm.titleMessage))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.message))]),
          _vm._v(" "),
          _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("cop.warning.message.common.scopWillServe")
              )
            }
          }),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("cop.warning.message.common.notEffected")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("cop.warning.message.common.askNumber1")))
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("cop.warning.message.common.askNumber2")))
          ]),
          _c(
            "span",
            {
              staticClass: "move_target",
              on: {
                click: function($event) {
                  return _vm.moveItVoc()
                }
              }
            },
            [_vm._v(_vm._s(_vm.systemItvoc))]
          ),
          _c("br"),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.systemPropMsg))]),
          _vm._v(" "),
          _c("a", { attrs: { href: "javascript:" } }, [
            _vm._v(_vm._s(_vm.$t("sdl.common.projectHelp")))
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.errorCode === "500"
            ? _c(
                "button",
                {
                  staticClass: "btn btn-lg btn-primary",
                  on: { click: _vm.goBack }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("cop.warning.label.goBack")) + "\n      "
                  )
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "btn btn-lg btn-primary",
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cop.warning.label.goHome")))]
              ),
          _vm._v(" "),
          _vm.showErrMsgYn
            ? _c(
                "button",
                {
                  staticClass: "btn btn-lg btn-primary",
                  on: {
                    click: function($event) {
                      return _vm.showErrMsg(_vm.msg)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cop.common.error-msg")))]
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c0c86e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c0c86e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/EmptyPage.vue
// module id = null
// module chunks = 